import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector} from 'react-redux'
import decode from 'jwt-decode'

import styles from '../Header/Header.module.css'

import { getSpecies } from '../../actions/actions'
import { getResponses } from '../../actions/responses'
import { getUsers } from '../../actions/auth'

const Header = () => {

    const history = useHistory()
    const location = useLocation()
    const allSpecies = useSelector(state => state.posts)
    const allUsers = useSelector(state => state.allUsers)
   
    //Retrieve user details from local storage
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    const [role, setRole] = useState(null)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getResponses())
        dispatch(getSpecies())
        dispatch(getUsers())
    }, [dispatch, location])

    useEffect(()=> {
        const token = user?.token

        setUser(JSON.parse(localStorage.getItem('profile')))
        setRole(user?.result.role)
        

        //If token expires, logout the user
        if(token) {
            const decodedToken = decode(token)
            if(decodedToken.exp * 1000 < new Date().getTime()) logout()
        }
        // eslint-disable-next-line
    }, [location, user]) //when location changes, set the user


    const logout =() => {
        dispatch({ type: 'LOGOUT' })

        history.push('/')
        setUser(null)
        setRole(null)
    }    
    
    return (
        <div>
            <section className={styles.header}>
            <Link to="/" style={{ textDecoration: 'none' }}>
                <h3 className={styles.logo}> WABBIS</h3>
            </Link>
               <div>
               {(role === 'admin') && (
                    <div className={styles.menuLinks}>
                    <Link to="/admin" style={{ textDecoration: 'none' }} ><p>Species <span className={styles.number}>{`[${allSpecies.length}]`}</span></p></Link>
                    <Link to="/activities" style={{ textDecoration: 'none' }} ><p>Activities</p></Link>
                    <Link to="/users" style={{ textDecoration: 'none' }} ><p>Users <span className={styles.number}>{`[${allUsers.length}]`}</span></p></Link>
                    <Link to="/log" style={{ textDecoration: 'none' }} ><p>Log</p></Link>
                </div>
                )}
               </div>

                <div>
                {
                user? 
                (<div className={styles.toolbar}>
                    <Link to="/profile" style={{ textDecoration: 'none' }}>
                        <div className={styles.avatarContainer}>{user.result.imageUrl || user.result.profilePicture? (<img src={user.result.imageUrl || user.result.profilePicture} alt="avatar" className={styles.avatar} />) : (<div className={styles.char}>{user.result.name.charAt(0)}</div>)}</div>
                    </Link>
                    <div className={styles.name}>{user.result.name}</div>
                    <div><button className={styles.logout} onClick={logout}>Logout</button></div>
                </div>) 
                :
                (<div>
                    <Link to="/login">
                        <button className={styles.login}>Login</button>
                    </Link>
                </div>)
                }
                </div>
            </section> 
        </div>
    )
}

export default Header
